namespace Matrix.Data {
    export namespace SecurityMatchRulesetRuleService {
        export const baseUrl = 'Data/SecurityMatchRulesetRule';

        export declare function Create(request: Serenity.SaveRequest<SecurityMatchRulesetRuleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SecurityMatchRulesetRuleRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SecurityMatchRulesetRuleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SecurityMatchRulesetRuleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/SecurityMatchRulesetRule/Create",
            Update = "Data/SecurityMatchRulesetRule/Update",
            Delete = "Data/SecurityMatchRulesetRule/Delete",
            Retrieve = "Data/SecurityMatchRulesetRule/Retrieve",
            List = "Data/SecurityMatchRulesetRule/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SecurityMatchRulesetRuleService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
